import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {RequestStepStatus} from '../../../shared/workflow/workflow-v2.interface';

@Component({
  selector: 'gp-workflow-step-status',
  templateUrl: './workflow-step-status.component.html',
  styleUrls: ['./workflow-step-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowStepStatusComponent {

  @Input()
  public status: RequestStepStatus;
}
